export default __webpack_public_path__ + "static/farmerBitcoin-d26beda0250c8e89832c3735b7a10f37.png";